import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-sans text-warm-dark selection:bg-terracotta/30 selection:text-navy" data-id="element-222">
      <HeroSection data-id="element-223" />
      <PainSection data-id="element-224" />
      <RevelationSection data-id="element-225" />
      <ValueStack data-id="element-226" />
      <FAQSection data-id="element-227" />
      <GuaranteeSection data-id="element-228" />
      <FinalCTA data-id="element-229" />

      <Footer data-id="element-230" />
    </main>;
}